import { AuthRedirect } from "../../auth/authRedirect";
import { GlobalPermissions } from "../../integrated-client";

export interface IAuthStateData {
  authManager?: AuthRedirect | null;
  userPermissions?: GlobalPermissions | null;
  isLoggedIn?: boolean;
  children?: React.ReactNode;
}

export class AuthStateData implements IAuthStateData {
  authManager?: AuthRedirect | null;
  userPermissions?: GlobalPermissions | null;
  isLoggedIn?: boolean;

  constructor() {
    this.authManager = null;
    this.userPermissions = null;
    this.isLoggedIn = false;
  }
}
